import * as constants from "../constants/slack";

export const initialState = {
  authenticating: false,
  hasCode: true,
  authenticated: false,
  hasError: false
};

const slack = (state = initialState, action = {}) => {
  switch (action.type) {
    case constants.AUTHENTICATED_SLACK_ERROR: {
      return Object.assign({}, initialState, {
        hasError: true
      });
    }
    case constants.AUTHENTICATED_SLACK: {
      return Object.assign({}, initialState, {
        authenticated: true
      });
    }
    case constants.AUTHENTICATING_SLACK: {
      return Object.assign({}, initialState, {
        authenticating: true
      });
    }
    case constants.NO_SLACK_CODE: {
      return Object.assign({}, initialState, {
        hasCode: false
      });
    }
    default: {
      return initialState;
    }
  }
};

export default slack;



// WEBPACK FOOTER //
// ./src/reducers/slack.js